module.exports = __webpack_public_path__ + "static/jeff-zoom-d5dda5020432622168ea0b0535954822.jpg";